/**
 * 定义请求地址
 * @param local：本地mock
 * @param develop: 本地开发
 * @param feature: 测试环境
 * @param prepub: 预发环境
 * @param production: 线上环境
 */

const config = {
  local: 'http://127.0.0.1:3000/api',
  develop: 'http://121.40.239.205:8000/service',
  // develop: 'http://120.26.93.6:8084/service',
  feature: 'http://121.40.239.205:8000/service',
  prepub: 'https://preapi.tsign.cn/service',
  production: 'https://api.tsign.cn/service'
};

let customConfig = {
  'esign': ['localhost', 'web.dev.cn', 'test.web.tsign.cn', 'preweb.tsign.cn', 'web.tsign.cn'],
  'yonyou': ['yonyoutest.web.tsign.cn', 'yonyouweb.tsign.cn', 'yonyoupreweb.tsign.cn']
};

const api = () => {
  let DEVELOP = process.env.DEVELOP || false;
  let FEATURE = process.env.FEATURE || false;
  let PREPUB = process.env.PREPUB || false;
  let PRODUCTION = process.env.PRODUCTION || false;

  if (DEVELOP) {
    // 测试环境
    return config.develop;
  }
  if (FEATURE) {
    // 线上环境
    return config.feature;
  }
  if (PREPUB) {
    // 测试环境
    return config.prepub;
  }
  if (PRODUCTION) {
    // 线上环境
    return config.production;
  }
  return config.local;
};

const customSource = () => {
  const hostname = window.location.hostname;
  //
  let sourcename = 'esign';
  // ip 地址全部走 ‘esign’
  const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/; // ip地址
  if (reg.test(hostname)) {
    return sourcename;
  }

  for (let source in customConfig) {
    if (customConfig[source].indexOf(hostname) > -1) {
      sourcename = source;
      break;
    }
  }
  return sourcename;
};


const API = api();
const SOURCE = customSource();
const LOCAL = config.local;

export {
  API,
  LOCAL,
  SOURCE
};



// WEBPACK FOOTER //
// ./src/resource-api/config.js